// Which auth provider the SPA uses. Build-time selection (a CRA env var), the
// frontend mirror of the backend's BETTER_AUTH_ENABLED flag.
//
// Values: 'firebase' (default) | 'better-auth' | 'null'
// Back-compat: REACT_APP_AUTHENTICATE_USERS=NO still selects the null provider.
export const AUTH_PROVIDER =
  process.env.REACT_APP_AUTH_PROVIDER ||
  (process.env.REACT_APP_AUTHENTICATE_USERS === 'NO' ? 'null' : 'firebase');

export const isFirebase = AUTH_PROVIDER === 'firebase';
export const isBetterAuth = AUTH_PROVIDER === 'better-auth';
export const isNullAuth = AUTH_PROVIDER === 'null';
